<lib-not-modal [width]="'min(720px, 96dvw)'">
  <div class="staff-order-catalog-picker">
    <div class="staff-order-catalog-picker__head">
      <h3 class="staff-order-catalog-picker__title">
        {{ 'admin.storageRequests.orderItemsAddFromCatalog' | translate }}
      </h3>
      <p class="staff-order-catalog-picker__hint">
        {{ 'admin.storageRequests.orderItemsCatalogHint' | translate }}
      </p>
    </div>

    @if (loading()) {
      <p class="staff-order-catalog-picker__loading" role="status">
        {{ 'common.loading' | translate }}
      </p>
    } @else if (items().length === 0) {
      <p class="staff-order-catalog-picker__empty">
        {{ 'admin.storageRequests.orderItemsCatalogEmpty' | translate }}
      </p>
    } @else {
      <ul class="staff-order-catalog-picker__list">
        @for (item of items(); track item.id) {
          <li class="staff-order-catalog-picker__row">
            <label class="staff-order-catalog-picker__check">
              <input
                type="checkbox"
                [checked]="isSelected(item.id)"
                (change)="toggleSelection(item.id)"
              />
              <span class="staff-order-catalog-picker__preview">
                @if (previewUrl(item.id); as url) {
                  <img [src]="url" alt="" decoding="async" />
                } @else {
                  <img
                    src="/icons/core/no-photo.svg"
                    alt=""
                    width="40"
                    height="40"
                    decoding="async"
                  />
                }
              </span>
              <span class="staff-order-catalog-picker__info">
                <span class="staff-order-catalog-picker__name-row">
                  <span class="staff-order-catalog-picker__name">{{
                    item.name
                  }}</span>
                  @if (itemQuantityBadge(item); as badge) {
                    <span class="staff-order-catalog-picker__quantity-badge">{{
                      badge
                    }}</span>
                  }
                </span>
                <span
                  class="staff-order-catalog-picker__status"
                  [class]="
                    'staff-order-catalog-picker__status--' +
                    statusModifier(item.status)
                  "
                >
                  {{ itemStatusLabelKey(item.status) | translate }}
                </span>
                @if (itemMetaLabel(item); as meta) {
                  <span class="staff-order-catalog-picker__meta">{{ meta }}</span>
                }
              </span>
            </label>
          </li>
        }
      </ul>
    }

    <div class="staff-order-catalog-picker__actions">
      <lib-cabinet-button
        variant="tertiary"
        size="lg"
        [fullWidth]="true"
        [text]="'common.actions.cancel' | translate"
        [action]="{ type: 'action' }"
        [disabled]="saving()"
        (actionEvent)="close()"
      />
      <lib-cabinet-button
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="
          'admin.storageRequests.orderItemsAddSelected'
            | translate : { count: selectedIds().length }
        "
        [action]="{ type: 'action' }"
        [disabled]="!canSubmit()"
        [isLoading]="saving()"
        (actionEvent)="submit()"
      />
    </div>
  </div>
</lib-not-modal>
